import { VoiceRoleplaySession } from '../types/session';
import { use11Labs } from './use11Labs';

export type ProviderType = '11labs' | 'openai';

export interface ConversationParams {
  session: VoiceRoleplaySession;
  startTimeRef: React.MutableRefObject<number>;
  isIntroCompletedRef: React.MutableRefObject<boolean>;
  setIsAISpeaking: (isSpeaking: boolean) => void;
  setError: (error: string | null) => void;
  language: string;
  voiceId?: string;
}

export type TranscriptEntry = {
  source: 'ai' | 'user';
  message: string;
  timestamp: Date;
};

export interface ConversationInterface {
  connectConversation: () => Promise<void>;
  disconnectConversation: () => void;
  transcript: TranscriptEntry[];
}

export function useConversation(
  provider: ProviderType,
  params: ConversationParams,
): ConversationInterface {
  return use11Labs(params);
}
